import { api } from './api';

export interface SlaByStepDto {
  workflowStepId: string;
  stepName: string;
  workflowName: string;
  totalInProgress: number;
  totalCompleted: number;
  totalOverdue: number;
  averageCompletionMinutes: number | null;
}

export interface OverdueSlaDto {
  documentId: string;
  documentTitle: string;
  workflowStepId: string;
  stepName: string;
  startedAt: string | null;
  dueDate: string | null;
  overdueMinutes: number;
  currentAssignees: string | null;
}

export interface SlaPerformanceDto {
  userId: string;
  userName: string;
  totalActions: number;
  onTimeActions: number;
  overdueActions: number;
  onTimePercentage: number;
  averageResponseMinutes: number | null;
}

export interface PaginatedOverdueResult {
  data: OverdueSlaDto[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

class SlaDashboardService {
  async getByStep(customerId: string): Promise<SlaByStepDto[]> {
    const { data } = await api.get<SlaByStepDto[]>('/sla-dashboard/by-step', {
      params: { customerId },
    });
    return data;
  }

  async getOverdue(
    customerId: string,
    page: number = 1,
    pageSize: number = 50
  ): Promise<PaginatedOverdueResult> {
    const { data } = await api.get<PaginatedOverdueResult>('/sla-dashboard/overdue', {
      params: { customerId, page, pageSize },
    });
    return data;
  }

  async getPerformance(
    customerId: string,
    fromIso: string,
    toIso: string
  ): Promise<SlaPerformanceDto[]> {
    const { data } = await api.get<SlaPerformanceDto[]>('/sla-dashboard/performance', {
      params: { customerId, from: fromIso, to: toIso },
    });
    return data;
  }
}

export const slaDashboardService = new SlaDashboardService();
